import { render, staticRenderFns } from "./VCardProPatientCForm.vue?vue&type=template&id=a8257d4e&scoped=true"
import script from "./VCardProPatientCForm.vue?vue&type=script&lang=js"
export * from "./VCardProPatientCForm.vue?vue&type=script&lang=js"
import style0 from "./VCardProPatientCForm.vue?vue&type=style&index=0&id=a8257d4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8257d4e",
  null
  
)

export default component.exports